@let ttmImage = ttmImages()[currentIndex];
@let ttmImageDistanceLet = ttmImageDistance();

<div class="content">
    <div class="close-btn-wrapper">
        <button mat-icon-button (click)="close.emit()" aria-label="Close">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="images-nav">
        <button mat-icon-button (click)="previous()" [disabled]="currentIndex === 0">
            <mat-icon>chevron_left</mat-icon>
        </button>

        <div class="images">
            <app-codalt-image fit="contain" [url]="'ttm-images/image/' + ttmImage?.id" [showLogo]="false"></app-codalt-image>
        </div>

        <button mat-icon-button (click)="next()" [disabled]="currentIndex === ttmImages().length - 1">
            <mat-icon>chevron_right</mat-icon>
        </button>
    </div>
    @if (ttmImages().length) {
        <mat-chip-list class="ttmimage-chips">
            @if (ttmImage?.ttm_status_key) {
                <app-status-chip class="chip-spacing" [statusKey]="ttmImage?.ttm_status_key" [ttmStatuses]="ttmStatuses()"></app-status-chip>
            }
            <mat-chip class="chip-spacing">
                <i class="fa-regular fa-calendar"></i> {{ttmImage?.created_at | date : 'd MMM yyyy H:mm'}}
            </mat-chip>
            @if (ttmImage?.user?.name) {
                <mat-chip class="chip-spacing">
                    <i class="fa-regular fa-user"></i> {{ttmImage?.user?.name}}
                </mat-chip>
            }
            @if (ttmImageDistanceLet && ttmImageDistanceLet.get && ttmImageDistanceLet.get(ttmImage?.id)) {
                <mat-chip (click)="onOpenLocation()" class="clickable">
                    <i class="fa-solid fa-location-dot"></i> {{ttmImageDistanceLet.get(ttmImage?.id)}}
                </mat-chip>
            }
        </mat-chip-list>
    }
</div>
